module.exports = __webpack_public_path__ + "favicon.svg?ffc4eaf10e658e7987311e38a579ca68";


//////////////////
// WEBPACK FOOTER
// ./src/assets/favicon.svg
// module id = 682
// module chunks = 0